import React from 'react';

export interface ExemptionDetails {
    exceptionDescription: string;
    category: string;
    link: string;
    justification: string;
}

export const useExemptionDetailsForm = (initial?: Partial<ExemptionDetails>) => {
    const [form, setForm] = React.useState<ExemptionDetails>({
        exceptionDescription: initial?.exceptionDescription ?? '',
        category: initial?.category ?? '',
        link: initial?.link ?? '',
        justification: initial?.justification ?? '',
    });

    const stateFormHandler = {
        exceptionDescription: {
            value: form.exceptionDescription,
            onChange: (e) => {
                setForm({
                    ...form,
                    exceptionDescription: e.target.value
                });
            },
            validation: {
                required: true
            }
        },
        category: {
            value: form.category,
            onChange: (e) => {
                const value = e?.target ? e.target.value : e;
                setForm({
                    ...form,
                    category: value
                });
            },
            validation: { 
                required: true
            }
        },
        link: {
            value: form.link,
            onChange: (e) => {
                setForm({
                    ...form,
                    link: e.target.value
                });
            },
            validation: {
                required: false
            }
        },
        justification: {
            value: form.justification,
            onChange: (e) => {
                setForm({
                    ...form,
                    justification: e.target.value
                });
            },
            validation: {
                required: true
            }
        },
    };

    return {
        form,
        stateFormHandler
    };
};
